import { render, staticRenderFns } from "./monitorDialog.vue?vue&type=template&id=1a8f48b6&scoped=true&"
import script from "./monitorDialog.vue?vue&type=script&lang=js&"
export * from "./monitorDialog.vue?vue&type=script&lang=js&"
import style0 from "./monitorDialog.vue?vue&type=style&index=0&id=1a8f48b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f48b6",
  null
  
)

export default component.exports